export default __webpack_public_path__ + "static/media/pinyons-plegador.8ab5dba3.png";